import { useEffect, useRef } from 'react';

/**
 * Incomplete Clippy state object.
 */
export interface ClippyState {
    isOpen: boolean;
    isClosing: boolean;
}

export default function useClippyStateUpdate(handleClippyUpdate: (newState: ClippyState) => void) {
    const unsubscribeClippy = useRef<() => void>();

    useEffect(() => {
        async function initialize() {
            const clippy = (await import(/* webpackChunkName: 'ClippyController' */ '../features/Clippy')).default;
            unsubscribeClippy.current = clippy.subscribe(handleClippyUpdate);
        }
        if (!unsubscribeClippy.current) {
            initialize();
        }
        return () => unsubscribeClippy.current?.();
    }, [handleClippyUpdate]);
}
